import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EnvConfigurationService} from './envconf.service';
import {ApiService} from './api.service';
import {Tires} from "../models/tire/Tires";
import {TireRequest} from "../models/tire/request/TireRequest";
import {TireSpecResponse} from "../models/tire/TireSpecResponse";

@Injectable({
  providedIn: 'root'
})
export class TireService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/tire`;


  /**
   * Constructor
   *
   * @param http httpClient
   *  @param apiService apiService
   */
  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}


  /**
   * Get all Sites by customer PK and name search
   *
   */
  loadTireInfosBySite(siteId:number): Observable<Tires> {
    console.log("TireService: Loading tire infos for site ID:", siteId);
    return this.http.get<Tires>(`${this.endpoint}/infos?siteId=${siteId}`);
  }

  /**
   * Save tire settings for a site
   * @param tireRequest
   */
  saveTireSettings(tireRequest: TireRequest) {
    return this.http.put<TireRequest>(`${this.endpoint}`, tireRequest);
  }

  getAllTireSpecs(): Observable<TireSpecResponse[]> {
    return this.http.get<TireSpecResponse[]>(`${this.endpoint}/tire-specs`);
  }

}
